<template>
    <vx-toast-manager
        :offset="{
            top: currentOffset,
        }"
        :mobileOffset="{
            top: currentOffset,
        }"
    ></vx-toast-manager>
</template>
<script setup>
import { getCurrentInstance, ref, computed, onMounted, watchEffect, nextTick } from 'vue';
import { VxToastManager } from '@voxie/frontend-components';
import { useEventListener, useScroll } from '@vueuse/core';
import { gsap } from 'gsap';

onMounted(() => {
    const app = getCurrentInstance();
    const $toasted = app?.appContext.config.globalProperties.$toasted;

    $toasted?.register('saved_successfully', 'Saved successfully.', { type: 'success' });
    $toasted?.register('platform_error', 'There was an error communicating with the platform.', {
        type: 'error',
    });
});

const { y: scrollY } = useScroll(window, { throttle: 16 });

const navbarHeight = ref(0);
const impersonationAlertHeight = ref(0);
const teamSuspendedAlertHeight = ref(0);
const currentOffset = ref(0);

const NAVBAR_SPACING = 32;

const measureElementsHeight = () => {
    const navbar = document.querySelector('.app-navbar');
    navbarHeight.value = navbar ? navbar.getBoundingClientRect().height : 0;

    const alert = document.querySelector('.impersonation-alert');
    impersonationAlertHeight.value = alert ? alert.getBoundingClientRect().height : 0;

    const suspendedAlert = document.querySelector('.team-suspended-alert');
    teamSuspendedAlertHeight.value = suspendedAlert ? suspendedAlert.getBoundingClientRect().height : 0;
};

const targetOffset = computed(() => {
    let baseOffset =
        navbarHeight.value + impersonationAlertHeight.value + teamSuspendedAlertHeight.value + NAVBAR_SPACING;

    const maxScrollReduction = baseOffset - NAVBAR_SPACING;
    const scrollReduction = Math.min(scrollY.value, maxScrollReduction);

    return Math.max(baseOffset - scrollReduction, NAVBAR_SPACING);
});

watchEffect(() => {
    gsap.to(currentOffset, {
        value: targetOffset.value,
        duration: 0.3,
    });
});

useEventListener(window, 'resize', () => {
    measureElementsHeight();
});

nextTick().then(() => {
    measureElementsHeight();
});
</script>
